import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useArtSizeUnit = () => {
  const { user } = useSelector((state) => state?.Login);
  const reduxUnit = user?.artSizeUnit;

  const [unit, setUnit] = useState("Centimeters");

  // redux change
  useEffect(() => {
    if (reduxUnit) {
      setUnit(reduxUnit);
      localStorage.setItem("artSizeUnit", reduxUnit);
    } else {
      const local = localStorage.getItem("artSizeUnit") || "Centimeters";
      setUnit(local);
    }
  }, [reduxUnit]);

  // guest change
  useEffect(() => {
    const handleChange = () => {
      const local = localStorage.getItem("artSizeUnit") || "Centimeters";
      setUnit(local);
    };

    window.addEventListener("artUnitChanged", handleChange);
    return () =>
      window.removeEventListener("artUnitChanged", handleChange);
  }, []);

  return unit;
};
